export const translations = {
  id: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      cashflow: 'Cashflow',
      transactions: 'Transaksi',
      debts: 'Hutang',
      receivables: 'Piutang',
      investors: 'Investor',
      taxes: 'Pajak',
      hr: 'HR & Kepegawaian',
      operational: 'Operasional',
      otherIncome: 'Pendapatan Lain',
      reports: 'Laporan',
      fieldTransactions: 'Transaksi Lapangan',
      userManagement: 'Manajemen User',
      auditLog: 'Audit Log',
      settings: 'Pengaturan',
      menuSettings: 'Pengaturan Menu',
      logout: 'Keluar'
    },
    // Common
    common: {
      save: 'Simpan',
      cancel: 'Batal',
      edit: 'Edit',
      delete: 'Hapus',
      add: 'Tambah',
      search: 'Cari',
      filter: 'Filter',
      loading: 'Memuat...',
      noData: 'Tidak ada data',
      confirm: 'Konfirmasi',
      yes: 'Ya',
      no: 'Tidak',
      all: 'Semua',
      actions: 'Aksi',
      status: 'Status',
      date: 'Tanggal',
      amount: 'Jumlah',
      total: 'Total',
      notes: 'Catatan',
      print: 'Cetak',
      export: 'Ekspor',
      refresh: 'Refresh'
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      cashToday: 'Saldo Kas Hari Ini',
      totalDebts: 'Total Hutang',
      totalReceivables: 'Total Piutang',
      netProfit: 'Laba Bersih Bulan Ini',
      cashflowPrediction: 'Prediksi Cashflow',
      netPosition: 'Posisi Netto',
      debtRatio: 'Rasio Hutang',
      critical: 'KRITIS',
      warning: 'PERINGATAN',
      cashBelowSafe: 'Saldo kas di bawah batas aman',
      negativeCashflow: 'Prediksi cashflow negatif dalam 7 hari',
      debtExceedsCash: 'Hutang melebihi 2x saldo kas'
    },
    // Transactions
    transactions: {
      title: 'Transaksi Komoditas',
      subtitle: 'Kelola pembelian dan penjualan dengan status pembayaran',
      purchases: 'Pembelian',
      sales: 'Penjualan',
      addPurchase: 'Tambah Pembelian',
      addSale: 'Tambah Penjualan',
      supplier: 'Supplier',
      buyer: 'Buyer',
      commodity: 'Komoditas',
      quantity: 'Kuantitas (kg)',
      pricePerKg: 'Harga per kg',
      brokerFee: 'Fee Makelar',
      paymentStatus: 'Status Bayar',
      paid: 'Lunas',
      partial: 'Sebagian',
      unpaid: 'Belum Bayar',
      dueDate: 'Jatuh Tempo',
      avgBuyPrice: 'Harga Beli Rata-rata',
      avgSellPrice: 'Harga Jual Rata-rata',
      marginPerKg: 'Margin per kg',
      volumeToday: 'Volume Hari Ini'
    },
    // Settings
    settings: {
      title: 'Pengaturan',
      subtitle: 'Kelola akun dan sistem',
      profile: 'Profil',
      myProfile: 'Profil Saya',
      editProfile: 'Edit Profil',
      fullName: 'Nama Lengkap',
      email: 'Email',
      changePassword: 'Ganti Password',
      currentPassword: 'Password Lama',
      newPassword: 'Password Baru',
      confirmPassword: 'Konfirmasi Password Baru',
      savePassword: 'Simpan Password Baru',
      minChars: 'Minimal 6 karakter',
      passwordMatch: 'Password cocok',
      passwordMismatch: 'Password tidak sama',
      backup: 'Backup & Database',
      databaseInfo: 'Informasi Database',
      backupData: 'Backup Data',
      autoBackup: 'Backup Otomatis Aktif',
      totalActivities: 'Total Aktivitas',
      lastLogin: 'Login Terakhir'
    },
    // Notifications
    notifications: {
      title: 'Notifikasi',
      noNotifications: 'Tidak ada notifikasi',
      allSafe: 'Semua hutang & piutang dalam kondisi aman',
      critical: 'Kritis',
      high: 'Tinggi',
      medium: 'Sedang',
      debt: 'Hutang',
      receivable: 'Piutang'
    },
    // Search
    search: {
      placeholder: 'Cari transaksi, pelanggan, supplier...',
      minChars: 'Ketik minimal 2 karakter untuk mencari...',
      noResults: 'Tidak ditemukan hasil untuk',
      pressEsc: 'Tekan ESC untuk menutup'
    },
    // Invoice
    invoice: {
      purchase: 'Invoice Pembelian',
      sale: 'Invoice Penjualan',
      receivable: 'Invoice Piutang',
      invoiceNumber: 'Nomor Invoice',
      printedBy: 'Dicetak oleh',
      printDate: 'Tanggal cetak',
      paymentHistory: 'Riwayat Pembayaran',
      remaining: 'Sisa'
    },
    // Auth
    auth: {
      welcome: 'Selamat Datang',
      loginSubtitle: 'Masuk ke dashboard Anda',
      login: 'Masuk',
      register: 'Daftar di sini',
      noAccount: 'Belum punya akun?'
    },
    // Messages
    messages: {
      loginSuccess: 'Login berhasil!',
      saveSuccess: 'Berhasil disimpan',
      deleteSuccess: 'Berhasil dihapus',
      updateSuccess: 'Berhasil diupdate',
      error: 'Terjadi kesalahan',
      confirmDelete: 'Apakah Anda yakin ingin menghapus?'
    }
  },
  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      cashflow: 'Cashflow',
      transactions: 'Transactions',
      debts: 'Debts',
      receivables: 'Receivables',
      investors: 'Investors',
      taxes: 'Taxes',
      hr: 'HR & Personnel',
      operational: 'Operational',
      otherIncome: 'Other Income',
      reports: 'Reports',
      fieldTransactions: 'Field Transactions',
      userManagement: 'User Management',
      auditLog: 'Audit Log',
      settings: 'Settings',
      menuSettings: 'Menu Settings',
      logout: 'Logout'
    },
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      loading: 'Loading...',
      noData: 'No data',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      actions: 'Actions',
      status: 'Status',
      date: 'Date',
      amount: 'Amount',
      total: 'Total',
      notes: 'Notes',
      print: 'Print',
      export: 'Export',
      refresh: 'Refresh'
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      cashToday: 'Cash Balance Today',
      totalDebts: 'Total Debts',
      totalReceivables: 'Total Receivables',
      netProfit: 'Net Profit This Month',
      cashflowPrediction: 'Cashflow Prediction',
      netPosition: 'Net Position',
      debtRatio: 'Debt Ratio',
      critical: 'CRITICAL',
      warning: 'WARNING',
      cashBelowSafe: 'Cash balance below safe limit',
      negativeCashflow: 'Negative cashflow predicted in 7 days',
      debtExceedsCash: 'Debt exceeds 2x cash balance'
    },
    // Transactions
    transactions: {
      title: 'Commodity Transactions',
      subtitle: 'Manage purchases and sales with payment status',
      purchases: 'Purchases',
      sales: 'Sales',
      addPurchase: 'Add Purchase',
      addSale: 'Add Sale',
      supplier: 'Supplier',
      buyer: 'Buyer',
      commodity: 'Commodity',
      quantity: 'Quantity (kg)',
      pricePerKg: 'Price per kg',
      brokerFee: 'Broker Fee',
      paymentStatus: 'Payment Status',
      paid: 'Paid',
      partial: 'Partial',
      unpaid: 'Unpaid',
      dueDate: 'Due Date',
      avgBuyPrice: 'Avg Buy Price',
      avgSellPrice: 'Avg Sell Price',
      marginPerKg: 'Margin per kg',
      volumeToday: 'Volume Today'
    },
    // Settings
    settings: {
      title: 'Settings',
      subtitle: 'Manage account and system',
      profile: 'Profile',
      myProfile: 'My Profile',
      editProfile: 'Edit Profile',
      fullName: 'Full Name',
      email: 'Email',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      savePassword: 'Save New Password',
      minChars: 'Minimum 6 characters',
      passwordMatch: 'Passwords match',
      passwordMismatch: 'Passwords do not match',
      backup: 'Backup & Database',
      databaseInfo: 'Database Information',
      backupData: 'Backup Data',
      autoBackup: 'Auto Backup Active',
      totalActivities: 'Total Activities',
      lastLogin: 'Last Login'
    },
    // Notifications
    notifications: {
      title: 'Notifications',
      noNotifications: 'No notifications',
      allSafe: 'All debts & receivables are in good condition',
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      debt: 'Debt',
      receivable: 'Receivable'
    },
    // Search
    search: {
      placeholder: 'Search transactions, customers, suppliers...',
      minChars: 'Type at least 2 characters to search...',
      noResults: 'No results found for',
      pressEsc: 'Press ESC to close'
    },
    // Invoice
    invoice: {
      purchase: 'Purchase Invoice',
      sale: 'Sale Invoice',
      receivable: 'Receivable Invoice',
      invoiceNumber: 'Invoice Number',
      printedBy: 'Printed by',
      printDate: 'Print date',
      paymentHistory: 'Payment History',
      remaining: 'Remaining'
    },
    // Auth
    auth: {
      welcome: 'Welcome',
      loginSubtitle: 'Sign in to your dashboard',
      login: 'Login',
      register: 'Register here',
      noAccount: "Don't have an account?"
    },
    // Messages
    messages: {
      loginSuccess: 'Login successful!',
      saveSuccess: 'Saved successfully',
      deleteSuccess: 'Deleted successfully',
      updateSuccess: 'Updated successfully',
      error: 'An error occurred',
      confirmDelete: 'Are you sure you want to delete?'
    }
  }
};
